<template>
    <div class="w-full flex flex-col">
        <div v-bind="$attrs" class="w-full inline-flex gap-4 flex-nowrap overflow-x-hidden" :class="{ 'is-paused': paused }">
            <div class="entries">
                <slot name="testimonials"></slot>
            </div>
            <div aria-hidden="true" class="entries">
                <slot name="testimonials"></slot>
            </div>
        </div>
        <div class="marquee-controls">
            <BaseButton
                theme="tertiary"
                size="sm"
                icon-only
                :aria-label="paused ? t('onboarding.testimonial.playButton') : t('onboarding.testimonial.pauseButton')"
                @click="paused = !paused">
                <i :class="['bi', paused ? 'bi-play-fill' : 'bi-pause-fill']" aria-hidden="true"></i>
            </BaseButton>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

defineOptions({ inheritAttrs: false });

const { t } = useI18n();

const paused = ref(false);
</script>

<style scoped>
@reference "../../../css/tailwind.css";
.entries {
    @apply flex flex-row gap-4 items-center justify-stretch animate-infinite-scroll;
}

.is-paused .entries {
    animation-play-state: paused;
}

/* Right inset matches the cards' own `mx-4`, so the control lines up with the strip's edge. */
.marquee-controls {
    @apply mt-2 flex justify-end pr-4;
}

@media (prefers-reduced-motion: reduce) {
    .marquee-controls {
        display: none;
    }
}
</style>
